module.exports = __webpack_public_path__ + "img/tune.acbb9ad8.svg";